<span style="position: relative">
  <mat-toolbar>
    <div fxHide.gt-sm>
      <button mat-icon-button (click)="onToggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div>
      <a [routerLink]="['/']">
        <img
          style="width: 120px"
          src="assets/img/everight-logo-small.png"
          alt="logo"
        />
      </a>
    </div>
    <!-- <div fxFlex fxLayout fxLayoutAlign="end" fxHide.xs>
      <img class="message" src="assets/icons/message.svg" alt="" />
    </div> -->
  </mat-toolbar>
</span>
